<template>
  <div class="table-wrap">
    <header>
      <h4>Tipos de Vouchers</h4>
    </header>
    <table class="transparent-table">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Descrição</th>
          <th>Modelo</th>
          <th>Categoria Loja</th>
          <th>Nominal</th>
          <th>Duração</th>
          <th>Valor</th>
          <th>Porcentagem</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="tiposVoucher">
        <tr v-for="voucher in tiposVoucher" :key="voucher.id">
          <td>{{ voucher.nomeTipoVoucher }}</td>
          <td>{{ voucher.descricaoVoucher }}</td>
          <td>{{ voucher.modelo}}</td>
          <td>{{ voucher.tipo }}</td>
          <td>
            <span
              v-if="voucher.nominal !== null && voucher.nominal !== '' && voucher.nominal !== undefined"
              :class="['marker', nominalClass(voucher.nominal)]"
            >
              {{ asSimNao(voucher.nominal) }}
            </span>
            <span v-else>-</span>
          </td>
          <td>{{ voucher.duracaoDias}} dias</td>
          <td>{{ formatField(voucher.valor) }}</td>
          <td>{{ formatField(voucher.porcentagem) }}</td>
          <td class="actions">
            <!-- <a href="#" @click.prevent="confirmRemove(voucher)" class="action">
              <fa :icon="['fal','trash-can']" class="icon"></fa>
            </a> -->
            <a href="#" @click.prevent="edit(voucher.idTipoVoucher)" class="action">
              <fa :icon="['fal','pencil']" class="icon"></fa>
            </a>
          </td>
        </tr>
      </tbody>
    </table> 
  </div>
  <confirm 
    :backdrop="false"
    class="confirm"
    ref="confirm"
  ></confirm>
  
</template>
<script>
import MarketplaceService from '@/services/marketplace.service.js'

export default {
  components: {
    // Modal, NovoVoucher
  },
  data() {
    return {
      tiposVoucher: [], 
      voucher: null
    }
  },
  mounted () {
    this.getTipoVoucher()
  },
  methods: {
    formatField(val) {
      return val !== null && val !== '' ? val : '-'
    },
    getTipoVoucher() {
      MarketplaceService.getTipoVoucher(0)
      .then((response) => {
        console.log()
        this.tiposVoucher = response.data
      }).catch( error => {
        console.error(error)
      })
    },
    asSimNao(val) {
      if (val === 1 || val === '1' || val === true) return 'Sim'
      if (val === 0 || val === '0' || val === false) return 'Não'
      return '-'
    },
    nominalClass(val) {
      if (val === 1 || val === '1' || val === true) return 'sim'
      if (val === 0 || val === '0' || val === false) return 'nao'
      return ''
    },
    edit(id) {
      this.$router.push({ name: 'Vouchers', params: { section: 'editar', id } })
    },
    confirmRemove(voucher) {
      this.$refs.confirm.run({
        message: 'Tem certeza que deseja remover a categoria selecionada?',
        confirmButton: 'Sim',
        denyButton: 'Não',
        data: [voucher],
        callback: this.remove
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .marker {
    padding: $hmg_mini;
    border-radius: $border-radius-small;

    &.nao {
      background-color: $color-warning;
      color: $color-secondary;
    }
    &.sim {
      background-color: $color-success;
      color: $color-secondary;
    }
  }


header {
    padding: $hmg_small;

    &.header {
      padding: $hmg_small;
      display: flex;
      align-items: center;
    }

    h4 {
      margin: 0;
    }
    .btn {
      margin-left: $hmg;
    }
  }

  .transparent-table{
    position: relative;
    top: 10px;
    th, td {
      &:last-child {
        max-width: 100px;

      }
    }
  }
  .table-wrap {
    padding: $hmg $hmg_small $mg_extra;
  }
  .actions {

    a{
      width: 100%;
    }

    display: flex;
    width: 100%;
    justify-content: space-between;
  }

</style>
